import types from '../types'

const initialState = {
  originKind: null,
  destinationKind: null,
  originLatLng: null,
  destinationLatLng: null,
  handoverModeId: null,
}

const searchParamsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ORIGIN_KIND_CHANGE:
      return {
        ...state,
        originKind: action.kind,
      }
    case types.DESTINATION_KIND_CHANGE:
      return {
        ...state,
        destinationKind: action.kind,
      }
    case types.ORIGIN_LATLNG_CHANGE:
      return {
        ...state,
        originLatLng: action.latLng,
      }
    case types.DESTINATION_LATLNG_CHANGE:
      return {
        ...state,
        destinationLatLng: action.latLng,
      }
    case types.SET_HANDOVER_MODE:
      return {
        ...state,
        handoverModeId: action.modeId
      }
    default:
      return state
  }
}

export default searchParamsReducer
